import React from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { DataList, formatListData } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { actions } from '../../actions/conversions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { gstConfig, DEFAULT_CONFIG } from './gstConfig';
import { TransactionRange } from '../../utils/type';

const useConversions = () => {
	const location = useLocation();
	const getOfferData = () => {
		const offers = _get(location, ['state', 'rowData'])?.offerDetail?.transactionRange?.map(
			(offer: TransactionRange, index: number) => {
				return {
					start: offer?.range?.start,
					end: offer?.range?.end,
					offerPercentage: offer?.offerPercentage,
					cashbackPercentage: offer?.cashbackPercentage,
					bonusPercentage: offer?.bonusPercentage,
					index: index + 1
				};
			}
		);
		return { rowCount: offers?.length, data: formatListData(offers) };
	};
	const { getActionHandler } = useDashboardActions(makeActionHandler, makeActionList);
	return { getOfferData, getActionHandler };
};

const OfferDetail: React.FC<{}> = () => {
	const { getOfferData, getActionHandler } = useConversions();
	return (
		<div>
			<DataList
				fetchData={getOfferData}
				columnConfigs={gstConfig}
				defaults={DEFAULT_CONFIG}
				actions={actions}
				getActionHandler={getActionHandler}
				disableColumnFilter
				entity={LIST_ENTITY_NAMES.GST_OFFERS}
			/>
		</div>
	);
};

export default OfferDetail;
